import palette from './palette';

const { redToyota, red } = palette;

const colors = {
  appBackground: redToyota,
  error: red,
};

export default colors;
